<template>
  <img :src="imageSrc" v-bind="$attrs" ref="image" @error="handleImageError" />
</template>

<script>
import { staticImgBaseUrl } from "../config/apiEndpoints";
import { keyMapsGetter } from "../helpers/storeKeys";

export default {
  props: ["src", "srcPlaceholder", "intersectionOptions"],
  data() {
    return {
      observer: null,
      isIntersected: false,
    };
  },
  computed: {
    imageSrc() {
      return this.isIntersected ? this.src : this.srcPlaceholder;
    },
  },
  methods: {
    handleImageError(event) {
      const img =
        this.$store.getters[keyMapsGetter.GET_PLACE_HOLDER_IMAGE]?.square;
      const fallBack =
        staticImgBaseUrl + "/images/global/default-product-img-lg.png";
      event.target.src = img || fallBack;
      event.target.onerror = null;
    },
  },
  mounted() {
    if ("IntersectionObserver" in window) {
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.isIntersected = true;
          this.observer.disconnect();
        }
      }, this.intersectionOptions);
      this.observer.observe(this.$refs.image);
    }
  },
  unmounted() {
    if ("IntersectionObserver" in window && this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>
